import * as React from 'react';
import { legacy_connect as connect } from 'react-redux';
import { actionCreators as draftActionCreators } from 'app/area/case/draft/actions';

type ImmediateSaveDispatchToProps = {
  requestImmediateSave: () => Promise<void>;
};

type ImmediateSaveOwnProps = {
  onChange?: (value: any) => void;
};

export const withImmediateSaveOnClick = (Component: any) => {
  const dispatchToProps = (dispatch: any): ImmediateSaveDispatchToProps => ({
    requestImmediateSave: async () => await dispatch(draftActionCreators.requestImmediateSave())
  });

  const WrappedComponent = (props: ImmediateSaveOwnProps & ImmediateSaveDispatchToProps) => {
    const {
      onChange,
      requestImmediateSave,
      ...remainingProps
    } = props;

    const onToggleClick = (value: any) => {
      onChange && onChange(value);
      requestImmediateSave();
    };

    return <Component {...remainingProps} onChange={onToggleClick} />;
  };

  return connect<any, any, any>(undefined, dispatchToProps)(WrappedComponent);
};
